var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuratedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.507812,
    y: 3.35938,
    width: 12.9844,
    height: 8.31771,
    rx: 1.49219,
    stroke: "#3F4D65",
    strokeWidth: 1.01562
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6525 3.43359V11.8919",
    stroke: "#3F4D65",
    strokeWidth: 1.01562
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73828 3.43359V11.8919",
    stroke: "#3F4D65",
    strokeWidth: 1.01562
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33338 2.85306V2.69922C9.33338 1.75641 9.33338 1.28501 9.04049 0.992112C8.74759 0.699219 8.27619 0.699219 7.33338 0.699219H6.30774C5.36493 0.699219 4.89353 0.699219 4.60063 0.992112C4.30774 1.28501 4.30774 1.75641 4.30774 2.69922V2.85306",
    stroke: "#3F4D65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratedIcon);
export default __webpack_public_path__ + "static/media/Curated_Icon.46b07bb30259c907ff7f6600e8748e56.svg";
export { ForwardRef as ReactComponent };